import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  menuTitleArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '0.5rem'
  },

  menuTitle: {
    fontSize: theme.size.base
  },

  menuClose: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },

  menuFormControl: {
    maxHeight: '50vh',
    overflowY: 'auto'
  },

  checkboxLabel: {
    fontSize: theme.size.sm,
    userSelect: 'none'
  },

  controlLabelBold: {
    fontSize: theme.size.sm,
    userSelect: 'none'
  }
}))

export default useStyles
